'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAssignedAgentFromV2Message = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _setters = require('../../operators/conversation/setters');

var _pubnubMessageGetters = require('../../pubnub-message/operators/pubnubMessageGetters');

var _assignmentV2MessageMetadataGetters = require('../../assignment-v2-message-metadata/operators/assignmentV2MessageMetadataGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setAssignedAgentFromV2Message = exports.setAssignedAgentFromV2Message = (0, _curry2.default)(function (assignmentV2Message, thread) {
  var agentId = (0, _pipe2.default)(_pubnubMessageGetters.getMetadata, _assignmentV2MessageMetadataGetters.getAssignedAgentId)(assignmentV2Message);
  return (0, _setters.setAssignedAgentId)(agentId, thread);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread/operators/setAssignedAgentFromV2Message.js
// module id = 868
// module chunks = 2 3